export default {
  /** beneLanding: "/logged-in" */
  beneLanding: "/logged-in",
  /** comparePlans: "/compare-plans" */
  comparePlans: "/compare-plans",
  /** coverageSelection: "/coverage-selection" */
  coverageSelection: "/coverage-selection",
  coverageWizard: {
    landingPage: "/coverage-options",
    options: "/coverage-options/options",
    info: "/coverage-options/info",
  },
  /** csrLanding: "/csr" */
  csrLanding: "/csr",
  /** drugSearchPreferences: "/drug-search-preferences" */
  drugSearchPreferences: "/drug-search-preferences",
  /** enroll: "/enroll" */
  enroll: "/enroll",
  /** enrollmentStatus: "/enrollment-status" */
  enrollmentStatus: "/enrollment-status",
  /** managePrescriptions: "/manage-prescriptions" */
  managePrescriptions: "/manage-prescriptions",
  /** mbpLandingPage: "/mbp-callback" */
  mbpLandingPage: "/mbp-callback",
  /** pdePage => "/add-prescriptions" */
  pdePage: "/add-prescriptions",
  /** pharmacy: "/pharmacy" */
  pharmacy: "/pharmacy",
  /** planDetails: "/plan-details/:id" */
  planDetails: "/plan-details/:id",
  /** prescriptionsList: "/view-prescriptions" */
  prescriptionsList: "/view-prescriptions",
  /** questionRouting: "/questions" */
  questionRouting: "/questions",
  /** sanctionedPlans: "sanctioned-plans" */
  sanctionedPlans: "/sanctioned-plans",
  /** searchResults: "/search-results" */
  searchResults: "/search-results",
  /** slsCallback: "/sls-callback" */
  slsCallback: "/sls-callback",
  version: "/version",
  planPreview: "/plan-preview/:id",
  /** Medigap */
  medigap: {
    landingPage: "/m",
    plans: "/m/plans",
    planDetails: "/m/plan-details/:medigapPlanType",
    policies: "/m/plan-policies/:medigapPlanType",
  },
};
